// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qXni","col":"styles_col__1hb3p"};